import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { ChangeOfAddress } from "./ChangeOfAddress";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { formatAddress, isValidArray } from "../../../../Layout/Common/common";
import { ShippingAddredKeys } from "../../../../constants";
import { CSSTransition } from "react-transition-group";
import Skeleton from "react-loading-skeleton";

export const ShippingAddress = () => {
  const { shippingAddress, IsInterNational, setChangeAddressClicked } = useContext(GlobalContext);
  const { clearSelectedShipService } = useGlobalFunction();
  const [shipAddress, setShipAddress] = useState(null);
  const divcontainerRef = useRef(null);
  const shippingAddressRef = useRef(null);

  useEffect(() => {
    if (shippingAddress) {
      setShipAddress(formatAddress(shippingAddress, ShippingAddredKeys));
    }
  }, [shippingAddress]);

  return (
    <div ref={divcontainerRef}>
      <div ref={shippingAddressRef} className="selected-shipping-address" id="shipping-address-fields">
        <h3>Shipping Address</h3>
        <div className="shipp-to">
          <div className="row">
            <div className="col-sm-9 col-lg-9">
              <div className="ship-address">
                <h5>Ship To</h5>
                <div className="ship-address-lft">
                  {shipAddress && isValidArray(shipAddress) ? (
                    <address>
                      {shipAddress.map((val, ind) => (
                        <p className="capitalize-text" key={ind}>
                          {String(val)}
                        </p>
                      ))}
                      <div className="delivery-instructions mt-3">
                        {shippingAddress && shippingAddress.deliveryInst}
                      </div>
                    </address>
                  ) : (
                    <Fragment>
                      <Skeleton width={300} count={5} />
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-3 col-lg-3">
              {!IsInterNational && (
                <button
                  type="button"
                  onClick={() => {
                    clearSelectedShipService();
                    setChangeAddressClicked(true);
                  }}
                  className="a-tag-button change-adress"
                >
                  Change
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
